<app-login-layout class="app-light-theme">
  <main class="ata-auth-page ata-auth-page--login">
    <header class="ata-auth-topbar">
      <a class="ata-auth-brand" routerLink="/auth">
        <span class="ata-auth-brand__mark">A</span>
        <span class="ata-auth-brand__name">Auto Transport Alliance</span>
      </a>

      <nav class="ata-auth-nav">
        <a class="ata-auth-nav__link is-active" routerLink="/auth">Log In</a>
        <a class="ata-auth-nav__link" routerLink="/register">Registration</a>
        <a class="ata-auth-nav__link" routerLink="/forgot-password">Forgot Password</a>
      </nav>
    </header>

    <section class="ata-auth-hero">
      <div class="ata-auth-hero__visual">
        <img src="assets/image/auth-hero-bg.jpg" alt="Carrier transport infrastructure" />
      </div>
      <div class="ata-auth-hero__overlay"></div>

      <div class="ata-auth-hero__inner">
        <div class="ata-auth-grid">
          <aside class="ata-auth-info">
            <div>
              <p class="ata-auth-info__eyebrow">Access</p>
              <h1 class="ata-auth-info__title">Sign in to your carrier workspace.</h1>
              <p class="ata-auth-info__copy">
                Manage dispatch operations, inspections, delivery evidence, and carrier-side workflows from one place.
              </p>

              <div class="ata-auth-info__list">
                <div class="ata-auth-info__item">
                  <p class="ata-auth-info__label">Security</p>
                  <p class="ata-auth-info__value">Protected authentication with controlled role access and token-based sessions.</p>
                </div>
                <div class="ata-auth-info__item">
                  <p class="ata-auth-info__label">Routing</p>
                  <p class="ata-auth-info__value">Direct access to dashboard after login, with preserved auth flow navigation.</p>
                </div>
              </div>
            </div>

            <p class="ata-auth-info__badge">Page 01</p>
          </aside>

          <section class="ata-auth-card">
            <p class="ata-auth-card__eyebrow">Authentication</p>
            <p class="ata-auth-card__intro">Use your registered carrier credentials to continue.</p>
            <app-login></app-login>
          </section>
        </div>
      </div>
    </section>
  </main>
</app-login-layout>
